import { firstFromArray, getIdList } from '@adaptiva/core/common';
import { UiService } from '@adaptiva/core/ui';
import { IMetadataAuthoringRule, MetadataSerialization, RulesProperties } from '@adaptiva/metadata/common';
import { ExpressionLanguageEditorComponent } from '@adaptiva/widgets/expression-editor';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { AuthoringRuleComponent } from '../authoring-rule';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-rules-properties',
	templateUrl: 'rules-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class RulesPropertiesComponent extends BaseAuthoringPropertiesComponent<RulesProperties> {

	@ViewChild('InstalledAuthoringRule')
	private _installedAuthoringRule: AuthoringRuleComponent;

	@ViewChild('InstallableAuthoringRule')
	private _installableAuthoringRule: AuthoringRuleComponent;

	@ViewChild('ApplicableRule')
	private _applicableRule: AuthoringRuleComponent;

	@ViewChild('InstallPathSensorExpressionEditor')
	private _installPathSensorExpressionEditor: ExpressionLanguageEditorComponent;

	public getIdList: Function = getIdList;

	public firstFromArray: Function = firstFromArray;

	public propertyConstructor: MetadataSerialization.Deserializable<RulesProperties> = RulesProperties;

	public installedRuleFromId: boolean = true;

	public commitModelToView(): void {
		const _local: RulesProperties = this.currentPropertyObject;
		const _inherited: RulesProperties | undefined = this.inheritedPropertyObject;

		const _installedRule: IMetadataAuthoringRule | null = (
			_local.InstalledAuthoringRuleObject || null
		);
		const _installableRule: IMetadataAuthoringRule | null = (
			_local.InstallableAuthoringRuleObject ||
			_inherited?.InstallableAuthoringRuleObject ||
			null
		);
		const _applicableRule: IMetadataAuthoringRule | null = (
			_local.ApplicableAuthoringRuleObject || null
		);

		this._installedAuthoringRule?.setValue(_installedRule);
		this._installableAuthoringRule?.setValue(_installableRule);
		this._applicableRule?.setValue(_applicableRule);
	}

	public deleteInstalledAuthoringRuleObject(): void {
		this.deleteObjectPropertyValue('InstalledAuthoringRuleObject');
		this._installedAuthoringRule?.setValue(null);
	}

	public deleteInstallableAuthoringRuleObject(): void {
		this.deleteObjectPropertyValue('InstallableAuthoringRuleObject');
		this._installableAuthoringRule?.setValue(this.inheritedPropertyObject?.InstallableAuthoringRuleObject);
	}

	public deleteInstallPathSensorExpression(): void {
		this.deleteObjectPropertyValue('InstallPathSensorExpression');
		this._installPathSensorExpressionEditor.setValue(this.inheritedPropertyObject.InstallPathSensorExpression || '');
	}

	public deleteApplicableRuleObject(): void {
		this.deleteObjectPropertyValue('ApplicableAuthoringRuleObject');
		this._applicableRule.setValue(this.inheritedPropertyObject?.ApplicableAuthoringRuleObject);
	}

	public isImportantNumber(input: number): boolean {
		return !isNaN(input);
	}

	public isImportantObject(input: object): boolean {
		return input && Object.values(input)?.length > 0;
	}

}
